import React from 'react'
import { ItalicWrapper } from '../../utils/typography/ItalicWrapper'
import { CompanyEntity } from 'types/CompanyEntity'

const normalizedName = <T extends string | null>(name: T) => (name === null ? null : name.replace(/ \(publ\)/, '')) as T

function CompanyName({ company }: { company: Pick<CompanyEntity, 'delistedDate' | 'name'> }) {
    return <ItalicWrapper isItalic={company.delistedDate}>{normalizedName(company.name)}</ItalicWrapper>
}

export { CompanyName, normalizedName }
